import {Request} from "./Request";
import {useState} from "react";
import {FormattedMessage} from "react-intl";

export const RequestContainer = (props) => {

    const [request, setRequest] = useState(null);

    function mappingStyle(mapping) {
        let color;
        switch (mapping) {
            case 'PUT':
                color = 'purple'
                break;
            case 'GET':
                color = '#282896FF'
                break;
            case 'POST':
                color = 'green'
                break;
            case 'DELETE':
                color = 'red'
                break;
            default:
                color = '#282896FF'
                break;
        }
        return color;
    }

    return (
        <div>
            <h2 onClick={() => {
                if (props.selected === props.title) {
                    props.setCategory('')
                } else {
                    props.setCategory(props.title)
                }
            }}><FormattedMessage id={props.title}/></h2>
            {props.selected === props.title && <div>
                {props.requests.map((r, i) => (
                    <div key={i}>
                        <div style={{display: "flex", marginBottom: '2%'}} onClick={() => {
                            if (r === request) {
                                setRequest('')
                            } else {
                                setRequest(r)
                            }
                        }}> <div style={{padding: 10}}>{r.number}</div>
                            <div className="pointer" style={{
                                backgroundColor: mappingStyle(r.mapping),
                                padding: 10,
                                color: "white",
                                borderRadius: "10%"
                            }}>{r.mapping}</div>
                            <div className="request-name">{r.requestName}</div>
                        </div>
                        {request === r && <Request request={r}></Request>}
                    </div>
                ))}
            </div>}
            <hr></hr>
        </div>
    )

}